import * as React from 'react';
import { clsx } from 'clsx';
import { LinkButton, UIHeading3, UIText1 } from '@cian/ui-kit';

import { Link } from '../../Link';
import { CloseButton } from '../components/CloseButton';

import { BigHeartIcon } from './icons/BigHeartIcon';
import * as styles from './MotivationPopupMobile.css';

export interface IMotivationPopupMobileProps {
  isVisible: boolean;
  onClose(): void;
}

export const MotivationPopupMobile: React.FC<IMotivationPopupMobileProps> = ({ isVisible, onClose }) => {
  return (
    <div
      className={clsx(styles['overlay'], isVisible && styles['overlay--visible'])}
      data-testid="MotivationPopupMobile"
    >
      <div className={styles['content']}>
        <div className={styles['close-button']}>
          <CloseButton onClick={onClose} />
        </div>
        <div className={styles['icon']}>{BigHeartIcon}</div>
        <div className={styles['title']}>
          <UIHeading3>
            Жилой комплекс добавлен <Link href="/favorites">в&nbsp;избранное</Link>
          </UIHeading3>
        </div>
        <UIText1>Авторизуйтесь, чтобы получить доступ к избранному с любого устройства</UIText1>
        <div className={styles['auth-button']}>
          <LinkButton href="/authenticate" theme="stroke_primary" fullWidth>
            Авторизоваться
          </LinkButton>
        </div>
      </div>
    </div>
  );
};
